/*
 * SPDX-FileCopyrightText: 2023 Genome Research Ltd.
 *
 * SPDX-License-Identifier: MIT
 */

import { 
	Row,
	Col,
  Widgets,
} from '@tol/tol-ui';

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) {
    return "Good morning - have a great day.";
  } else if (hour >= 17) {
    return "Good evening.";
  } else if (hour >= 12) {
    return "Good afternoon.";
  }
};

const title = (
  <span>
    <h2>{getGreeting()}</h2>
    <p className='mt-2'>
    Welcome to ToL Links, a site offering permanent link redirection to ToL pages. This ensures that published links remain relevant even if/when the underlying system changes.
    </p>
  </span>
);

const intro = (
  <Row>
    <Col xs={12} sm={8}>{title}</Col>
  </Row>
);

function Home() {
  const components = [
    {
      component: intro,
      type: 'full'
    }
  ];

  return (
    <div className="links">
      <Widgets components={components}/>
    </div>
  );
}
export default Home;